export function client(state) {
  return state.client;
}

export function accessToken(state) {
  return state.accessToken;
}

export function user(state) {
  return state.user;
}

export function authenticated(state) {
  return state.accessToken != null && state.tokenExpires > new Date();
}

export function authorized(state) {
  const user = state.user;
  return user && (user.role === "admin" || user.role === "external_admin") ;
}

export function isadmin(state) {
  const user = state.user;
  return user && (user.role === "admin") ;
}